// App.js

import React from 'react';
import '../App.css';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Footer from './Footer';

function App() {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Footer />
    </div>
  );
}

export default App;
